var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.049 8.692c.032.07.08.13.138.18l3.35 2.97c.261.216.463.074.463-.34V9h5.5a.5.5 0 000-1H7V5.438c0-.416-.214-.556-.462-.331l-3.351 2.96a.528.528 0 00-.138.625z",
    fill: "#1a1a1a"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjA0ODkgOC42OTE3MUMzLjA4MTEyIDguNzYxMjQgMy4xMjgwOSA4LjgyMjkyIDMuMTg2NTUgOC44NzI0Nkw2LjUzNzc5IDExLjg0MjRDNi43OTgyNiAxMi4wNTc3IDcgMTEuOTE2NCA3IDExLjUwMTlWOC45OTk5M0gxMi41QzEyLjc3NjEgOC45OTk5MyAxMyA4Ljc3NjA3IDEzIDguNDk5OTNDMTMgOC4yMjM3OSAxMi43NzYxIDcuOTk5OTMgMTIuNSA3Ljk5OTkzSDdMNyA1LjQzNzgxQzcgNS4wMjE1NiA2Ljc4NjM1IDQuODgxOTcgNi41Mzc3OSA1LjEwNjY5TDMuMTg2NTUgOC4wNjcyMUMzLjEyODA5IDguMTE2NzYgMy4wODExMiA4LjE3ODQ0IDMuMDQ4OSA4LjI0Nzk3QzMuMDE2NjkgOC4zMTc1IDMgOC4zOTMyMSAzIDguNDY5ODRDMyA4LjU0NjQ3IDMuMDE2NjkgOC42MjIxOCAzLjA0ODkgOC42OTE3MVoiIGZpbGw9IiMxYTFhMWEiLz4KPC9zdmc+Cg==";
export { SvgSmallArrowLeft as ReactComponent };